<template>
  <div class="childOrder">
    <!-- tabs -->
    <el-tabs type="card" v-model="activeName" @tab-click="handleTab">
      <el-tab-pane
        v-for="(item, index) of c_enterpriseChildTabsList"
        :name="item.name"
        :key="index"
      >
        <span slot="label">
          {{ item.label }}
          <el-popover width="200" trigger="hover" :content="item.tips">
            <i slot="reference" class="el-icon-info icon-info"></i>
          </el-popover>
        </span>
      </el-tab-pane>
    </el-tabs>
    <base-list-management
      ref="baseListManagement"
      :configData.sync="c_childOrderConfigData"
    />
  </div>
</template>
<script>
// api
import { FuzzySearch } from '@/api/purchaseAndSaleAPI'
import { searchByCustomerName } from '@/api/domain/customers'

// 配置
// eslint-disable-next-line import/no-cycle
import config from '../config'
import { mapGetters } from 'vuex'

export default {
  data() {
    const {
      // 模版数据
      c_childOrderConfigData,
      // tabsList
      c_enterpriseChildTabsList,
    } = config.call(this)
    return {
      c_enterpriseChildTabsList,
      c_childOrderConfigData,
      activeName: '2',
    }
  },
  computed: {
    ...mapGetters(['allCities']),
  },
  watch: {
    allCities: {
      handler(val) {
        this.c_childOrderConfigData.formData.list.find((item) => item.itemConfig.prop === 'adcode').elConfig.options.list = val
      },
      immediate: true,
    },
  },
  methods: {
    // 去客户还车页面
    // eslint-disable-next-line vue/no-unused-properties
    toReturnCarPage(row) {
      const queryObj = { orderId: row.id }
      const queryStr = JSON.stringify(queryObj)
      this.$router.push({
        name: 'return_lease_ent_start',
        query: {
          query: queryStr,
        },
      })
    },
    // 详情
    // eslint-disable-next-line vue/no-unused-properties
    toOrderDetailPage(row) {
      const path = '/underLease/underLeaseOrder/enterpriseChildDetail'
      const query = {
        id: row.id,
        orderType: 'enterChild',
      }
      this.$router.push({
        path,
        query,
      })
    },
    // 车牌号模糊查询
    // eslint-disable-next-line vue/no-unused-properties
    carRemoteMethod(query) {
      if (query.length >= 4) {
        FuzzySearch({
          state: 1,
          plateNo: query,
        }).then((res) => {
          const { data } = res
          this.$refs.baseListManagement?.setItemData({
            elConfigKey: 'list',
            key: 'carId',
            data,
          })
        })
      }
    },
    // tabs切换
    handleTab() {
      this.$refs.baseListManagement?.reset()
    },
    // eslint-disable-next-line vue/no-unused-properties
    dealWithSearch(val) {
      // 发车验车时间
      val.outStockTimeStart = (val.TheCarExTime && val.TheCarExTime[0]) || ''
      val.outStockTimeEnd = (val.TheCarExTime && val.TheCarExTime[1]) || ''
      delete val.TheCarExTime
      // 订单创建时间
      val.createTimeStart = (val.startTime && val.startTime[0]) || ''
      val.createTimeEnd = (val.startTime && val.startTime[1]) || ''
      delete val.startTime
      // 计租开始日
      val.rentStartTimeStart = (val.rentStartTime && val.rentStartTime[0]) || ''
      val.rentStartTimeEnd = (val.rentStartTime && val.rentStartTime[1]) || ''
      delete val.startTime
      // 计租结束日
      val.rentEndTimeStart = (val.rentFinIsh && val.rentFinIsh[0]) || ''
      val.rentEndTimeEnd = (val.rentFinIsh && val.rentFinIsh[1]) || ''
      delete val.rentFinIsh
      // 个人租赁订单固定参数
      val.bizType = 20 // 10个人订单 20企业子订单
      val.tabNo = Number(this.activeName) // tab
      // 品牌车系车型
      const { brandSeriesModel } = val
      val.brandId = brandSeriesModel.brandId
      val.seriesId = brandSeriesModel.seriesId
      val.modelId = brandSeriesModel.modelId
      delete val.brandSeriesModel
      return val
    },
    // eslint-disable-next-line vue/no-unused-properties
    customerRemoteMethod(query) {
      if (query.length >= 1) {
        searchByCustomerName({
          customerState: 1,
          customerType: 2,
          customerName: query,
        }).then((res) => {
          const { data } = res
          this.$refs.baseListManagement?.setItemData({
            elConfigKey: 'list',
            key: 'customerId',
            data,
          })
        })
      }
    },
  },
}
</script>
